import Guid from "_shared/guids/guid";

export default class CreateNetworkedGroupApiRequest {
  public constructor(
    public name?: string, 
    public description?: string, 
    public memberUserIds: Guid[] = []) { }
}
